import { render, staticRenderFns } from "./ActivityTreeNodeBookmarkModal.global.vue?vue&type=template&id=52bbdc40&scoped=true&lang=pug&"
import script from "./ActivityTreeNodeBookmarkModal.global.vue?vue&type=script&lang=ts&"
export * from "./ActivityTreeNodeBookmarkModal.global.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityTreeNodeBookmarkModal.global.vue?vue&type=style&index=0&id=52bbdc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbdc40",
  null
  
)

export default component.exports